export const activeClassname = 'onBase';
export const basePathDataValueKey = 'data-base-path-value';
export const homeBase = 0;
export const firstBase = 1;
export const secondBase = 2;
export const thirdBase = 3;
